import React, { useState } from "react";
import "./assets/css/App.css";
import "./global.css";
import Layout from "./Layout";
import Chat, { ChatData } from "./components/Chat";
import { BsChatLeftTextFill } from "react-icons/bs";
import Loading from "./components/Loading";
import { sendEmail }  from "./api/API";
import Message, { MessageType } from "./components/Message";
import { LanguageProvider } from "./LanguageContext";
import { LoadingProvider, useLoading } from "./contexts/LoadingContext";
import { MessageProvider, useMessage } from "./contexts/MessageContext";
import { useTranslate } from "./services/translation";

function AppContent() {
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { message, setMessage } = useMessage();
  const { translate } = useTranslate();
  const [isChat, setIsChat] = useState<boolean>(false);
  const handleClickOutside = (e:any) => {
    const target = e.target;
    const chatElement = document.querySelector('.chat');
    if (chatElement && !chatElement.contains(target) && isChat) {
      setIsChat(false);
    }
  };

  const handleSendMessage = async (data: ChatData) => {
    startLoading();
    const response = await sendEmail(data.email, data.telephone, data.content);

    if (response && response.status_code === 200) {
      setMessage({
        content: translate("common.message_sent"),
        type: MessageType.SUCCESS
      });
    } else {
      setMessage({
        content: translate("common.message_failed"),
        type: MessageType.CRITICAL
      });
    }

    stopLoading();
    setIsChat(false);
  }

  return (
    <div className="app background-1" onClick={handleClickOutside}>
      <Layout />
      {!isChat && (<span className="chat-btn gradient-bg fixed flex a-i-center j-c-center white" onClick={()=>setIsChat(true)}>
        <BsChatLeftTextFill />
      </span>)}
      {isChat && (<Chat submit={handleSendMessage}/>)}
      {isLoading && <Loading/>}
      {message.content !== "" && <Message content={message.content} type={message.type} callback={message.callback}/>}
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <LoadingProvider>
        <MessageProvider>
          <AppContent />
        </MessageProvider>
      </LoadingProvider>
    </LanguageProvider>
  );
}

export default App;
